export type { default as DockingViewState } from './store/schema/DockingViewState';
export { default as StickyBottomBorder } from './components/StickyBottomBorder';
export * from './utils/getDockingViewControls';
